import { Component } from '@angular/core';

@Component({
    selector: 'vw-emoji-meh-icon',
    imports: [],
    template: `<svg class="w-full h-full" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1699 22C17.6928 22 22.1699 17.5228 22.1699 12C22.1699 6.47715 17.6928 2 12.1699 2C6.64707 2 2.16992 6.47715 2.16992 12C2.16992 17.5228 6.64707 22 12.1699 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.16992 15H16.1699" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.16992 9H9.17992" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.1699 9H15.1799" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  `
})
export class EmojiMehIconComponent {

}
